var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5841 99.9148C47.9147 100.65 32.6887 96.6872 27.3191 84.3146C21.9495 71.942 27.3191 58.4936 27.3191 58.4936C27.3191 58.4936 31.7058 63.8134 32.1593 68.1764C32.7646 60.5858 32.2006 48.2727 40.9872 36.976C44.4117 41.22 45.4705 46.9279 45.4705 46.9279C45.4705 46.9279 47.0588 30.4612 54.9999 20.7783C60.2941 26.1577 62.4117 33.6888 63.9999 41.22C63.9999 41.22 66.1176 35.8406 68.3233 33.2105C72.7166 39.1278 78.2941 51.7693 77.2352 61.9902C79.3529 51.4408 81.5032 48.8107 81.5032 48.8107C81.5032 48.8107 88.8254 70.3282 82.4795 84.3146C78.3088 93.5069 71.7403 98.8389 57.5841 99.9148Z",
    fill: "url(#paint0_linear_1172_3989)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.206 86.1375C63.206 86.8803 59.5321 85.3306 55.0001 85.3306C50.4681 85.3306 46.7942 86.8803 46.7942 86.1375C46.7942 85.3948 50.4681 83.7168 55.0001 83.7168C59.5321 83.7168 63.206 85.3948 63.206 86.1375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6374 53.4275C93.0397 53.4275 94.1765 52.2724 94.1765 50.8475C94.1765 49.4227 93.0397 48.2676 91.6374 48.2676C90.2352 48.2676 89.0984 49.4227 89.0984 50.8475C89.0984 52.2724 90.2352 53.4275 91.6374 53.4275Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8095 34.7075C79.5482 34.7075 80.1471 34.099 80.1471 33.3484C80.1471 32.5978 79.5482 31.9893 78.8095 31.9893C78.0708 31.9893 77.4719 32.5978 77.4719 33.3484C77.4719 34.099 78.0708 34.7075 78.8095 34.7075Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5154 42.7761C28.9618 42.7761 29.3236 42.4085 29.3236 41.955C29.3236 41.5014 28.9618 41.1338 28.5154 41.1338C28.0691 41.1338 27.7073 41.5014 27.7073 41.955C27.7073 42.4085 28.0691 42.7761 28.5154 42.7761Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8824 24.067C36.1981 24.067 37.2647 22.9832 37.2647 21.6463C37.2647 20.3094 36.1981 19.2256 34.8824 19.2256C33.5666 19.2256 32.5 20.3094 32.5 21.6463C32.5 22.9832 33.5666 24.067 34.8824 24.067Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31.7345L98.6765 30.3896L97.3529 31.7345L98.6764 33.0793L100 31.7345Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.647 47.3351L11.3235 45.9902L9.99996 47.3351L11.3235 48.6799L12.647 47.3351Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5883 26.4072L18.8232 28.6176C18.6001 28.8969 18.6001 29.2969 18.8232 29.5763L20.5883 31.7866L18.413 29.9931C18.1381 29.7664 17.7444 29.7664 17.4695 29.9931L15.2942 31.7866L17.0593 29.5763C17.2824 29.2969 17.2824 28.8969 17.0593 28.6176L15.2942 26.4072L17.4695 28.2008C17.7444 28.4275 18.1381 28.4275 18.413 28.2008L20.5883 26.4072Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8026 29.0974L18.3118 29.4739L17.9412 37.0853L17.5706 29.4739L10.0798 29.0973L17.5706 28.7208L17.9412 21.1094L18.3118 28.7208L25.8026 29.0974Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1035 13.0322L66.0931 14.2975C65.9654 14.4574 65.9654 14.6863 66.0931 14.8462L67.1035 16.1115L65.8583 15.0848C65.7009 14.9551 65.4756 14.9551 65.3182 15.0848L64.073 16.1115L65.0834 14.8462C65.2111 14.6863 65.2111 14.4574 65.0834 14.2975L64.073 13.0322L65.3182 14.0589C65.4756 14.1887 65.7009 14.1887 65.8583 14.0589L67.1035 13.0322Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0883 14.5725L65.8004 14.788L65.5883 19.145L65.3761 14.788L61.0883 14.5725L65.3761 14.3569L65.5883 10L65.8004 14.3569L70.0883 14.5725Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0755 21.0052L89.1011 18.999L87.1268 21.0052L89.1011 23.0114L91.0755 21.0052Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1011 10.9814L89.4234 19.3256H88.7788L89.1011 10.9814Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1011 30.9789L89.4234 22.6348H88.7788L89.1011 30.9789Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9413 20.9798L90.7294 20.6523V21.3073L98.9413 20.9798Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2612 20.9798L87.4731 20.6523V21.3073L79.2612 20.9798Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2058 78.8757C46.814 78.8757 48.1176 77.0694 48.1176 74.8412C48.1176 72.613 46.814 70.8066 45.2058 70.8066C43.5977 70.8066 42.2941 72.613 42.2941 74.8412C42.2941 77.0694 43.5977 78.8757 45.2058 78.8757Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7941 78.8757C66.4022 78.8757 67.7059 77.0694 67.7059 74.8412C67.7059 72.613 66.4022 70.8066 64.7941 70.8066C63.186 70.8066 61.8823 72.613 61.8823 74.8412C61.8823 77.0694 63.186 78.8757 64.7941 78.8757Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1172_3989",
    x1: 54.6184,
    y1: 18.8977,
    x2: 55.3311,
    y2: 113.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB7E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241078,
    stopColor: "#F87C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378572,
    stopColor: "#F07800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490069,
    stopColor: "#E27100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587569,
    stopColor: "#CE6700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675979,
    stopColor: "#B45A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757877,
    stopColor: "#954A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83473,
    stopColor: "#6F3800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907512,
    stopColor: "#442200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974735,
    stopColor: "#140A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFired);
export default __webpack_public_path__ + "static/media/fired.c510db3a471473772527bc3af88d7406.svg";
export { ForwardRef as ReactComponent };